<template>
	<div class="pt-100 pb-100 question-list-item">
		<BaseButton
			classes="question-list-item__toggle justify-content-space-between text-align-left width-100"
			:mixpanel-element="props.mixpanelElement"
			:click-text="props.questionItem.question"
			@click="toggleDrawer"
		>
			<span class="heading-6 text-color-content-primary">
				{{ props.questionItem.question }}
			</span>
			<BaseSvgIcon class="dark ml-100" name="chevron" width="24" height="24" :dir="chevronDirection" />
		</BaseButton>
		<TransitionCollapse>
			<div v-if="isExpanded" class="mt-50 ml-200" v-html="props.questionItem.answer"></div>
		</TransitionCollapse>
	</div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import { QuestionItem } from 'types/layout';
import TransitionCollapse from '@components/layout/transition-collapse.vue';

interface Props {
	questionItem: QuestionItem;
	mixpanelElement?: string;
}

const props = withDefaults(defineProps<Props>(), {
	mixpanelElement: 'button'
});

const isExpanded = ref(false);

function toggleDrawer(): void {
	isExpanded.value = !isExpanded.value;
}

const chevronDirection = computed((): string => {
	return isExpanded.value ? 'up' : 'down';
});
</script>

<style lang="scss">
.question-list-item {
	.question-list-item__toggle {
		align-items: center;
		display: flex;
		flex-wrap: nowrap;
	}

	.svg-icon {
		position: relative;
	}
}
</style>
